import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Chip, TableCell, TableRow, Typography } from '@mui/material';

import { LinkText } from 'common/components';
import {
  DeleteOutline as DeleteOutlineIcon,
  OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';

import { isEven, nameOfPublishStatus } from 'utils/helpers';
import { colors } from 'themes';

const CardButton = styled(Button)``;

const chipColor = value => {
  switch (value) {
    case 1:
      return 'grey';
    case 2:
      return 'green';
    case 3:
      return 'error';
    case 4:
      return 'blue';
    default:
      return null;
  }
};

const { REACT_APP_LANDING_PAGE_URL } = process.env;

const SignupItem = ({
  createdAt,
  handleRemoveSignup,
  index,
  name,
  publishStatus,
  submissionsCount,
  uuid,
}) => {
  const { organizationUuid } = useParams();

  return (
    <TableRow sx={{ backgroundColor: isEven(index) ? colors.alabaster : colors.white }}>
      <TableCell
        sx={{
          fontWeight: 'bold',
          width: '25%',
        }}
      >
        <LinkText color="inherit" to={`/${organizationUuid}/signups/${uuid}?tab=0`}>
          <Typography variant="body1">{name}</Typography>
        </LinkText>
      </TableCell>
      <TableCell>{createdAt ? new Date(createdAt).toLocaleDateString('us-US') : ''}</TableCell>
      <TableCell>
        <Chip
          label={nameOfPublishStatus(publishStatus)}
          size="medium"
          color={chipColor(publishStatus)}
        />
      </TableCell>
      <TableCell>{submissionsCount ?? ''}</TableCell>
      <TableCell align="right">
        {publishStatus === 2 && (
          <CardButton
            component="a"
            href={`${REACT_APP_LANDING_PAGE_URL}/signup/${uuid}`}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<OpenInNewIcon />}
          >
            View live
          </CardButton>
        )}
        <CardButton
          color="error"
          onClick={() => handleRemoveSignup(uuid)}
          startIcon={<DeleteOutlineIcon />}
        >
          Delete
        </CardButton>
      </TableCell>
    </TableRow>
  );
};

SignupItem.propTypes = {
  createdAt: PropTypes.string,
  handleRemoveSignup: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  publishStatus: PropTypes.number.isRequired,
  submissionsCount: PropTypes.number,
  uuid: PropTypes.string.isRequired,
};

export default SignupItem;
